module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-cf9dab29827ebaacae38230213ba41ff.webp";